module.exports = __webpack_public_path__ + "img/UserSettings.779833e9.svg";